<ng-container *transloco="let t">
    @if (formGroup) {
    <div [formGroup]="formGroup">
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
            fxLayoutGap="10px"
            fxFlexFill
        >
            @for (field of fields; track field) { @if (isFieldVisible(field)) {
            <div
                [fxFlex]="fields.length === 2 ? '50' : '100'"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxFlexFill
            >
                <!-- BIRTH DATE -->
                @if (field.type === 'birth-date') {
                <mat-form-field appearance="outline" class="date-field">
                    <mat-label>{{
                        t(field.labelKey ?? field.label ?? field.key)
                    }}</mat-label>
                    <input
                        matInput
                        appDateMask
                        [matDatepicker]="birthdatePicker"
                        [formControlName]="field.key"
                        [autocomplete]="'birthDate' | autocomplete"
                        maxlength="10"
                        (dateChange)="
                            setAgeAtEnrollment(
                                $safeNavigationMigration(
                                    formGroup.get(field.key)?.value
                                )
                            )
                        "
                        [required]="isFieldRequired(field)"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="birthdatePicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #birthdatePicker></mat-datepicker>
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    @if ( formGroup.get(field.key)?.hasError('required') ) {
                    <mat-error
                        >{{ t("shared.error.required.birthdate") }}
                    </mat-error>
                    } @if ( formGroup.get(field.key)?.hasError('minimumAge') ) {
                    <mat-error>{{ t("shared.error.min.age") }} </mat-error>
                    } @if ( formGroup.get(field.key)?.hasError('maximumAge') ) {
                    <mat-error>{{ t("shared.error.max.age") }} </mat-error>
                    }
                </mat-form-field>
                }
                <!-- TEXT / NUMBER -->
                @if (field.type === 'text' || field.type === 'number') {
                <mat-form-field appearance="outline">
                    <mat-label
                        >{{ t(field.labelKey ?? field.label ?? field.key) }}
                    </mat-label>
                    <input
                        matInput
                        [type]="field.type === 'number' ? 'number' : 'text'"
                        [formControlName]="field.key"
                        [attr.maxlength]="getMaxLength(field)"
                    />
                    @if (field.hintKey) {
                    <mat-hint>{{ t(field.hintKey) }}</mat-hint>
                    } @for (validator of getValidators(field); track
                    validator.errorKey ?? validator.name) {
                    <mat-error>
                        {{
                            t(
                                validator.messageKey ??
                                    validator.message ??
                                    validator.name
                            ) ??
                                validator.messageKey ??
                                validator.message
                        }}
                    </mat-error>
                    }
                </mat-form-field>
                }
                <!-- EMAIL -->
                @if (field.type === 'email') {
                <mat-form-field appearance="outline">
                    <mat-label>{{
                        t(field.labelKey ?? field.label ?? field.key)
                    }}</mat-label>
                    <input
                        matInput
                        type="email"
                        [formControlName]="field.key"
                        [autocomplete]="'email' | autocomplete"
                        maxlength="200"
                    />
                    @for (validator of getValidators(field); track
                    validator.errorKey ?? validator.name) {
                    <mat-error>
                        {{
                            t(
                                validator.messageKey ??
                                    validator.message ??
                                    validator.name
                            ) ??
                                validator.messageKey ??
                                validator.message
                        }}
                    </mat-error>
                    }
                </mat-form-field>
                }
                <!-- SELECT -->
                @if (field.type === 'select') {
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{
                        t(field.labelKey ?? field.label ?? field.key)
                    }}</mat-label>
                    <mat-select
                        [formControlName]="field.key"
                        [required]="isFieldRequired(field)"
                        #select
                    >
                        <mat-option>
                            <ngx-mat-select-search
                                [formControl]="getFilterCtrl(field.key)"
                                [placeholderLabel]="
                                    t('shared.search-select.search')
                                "
                                [noEntriesFoundLabel]="
                                    t('shared.search-select.no-entries-found')
                                "
                                [clearSearchInput]="false"
                            ></ngx-mat-select-search>
                        </mat-option>
                        @for ( selection of (getFilteredOptions(field) | async)
                        ?? [] ; track selection) {
                        <mat-option
                            [value]="
                                field.key === 'MailingStateCode'
                                    ? selection.code
                                    : selection.selectionId
                            "
                        >
                            {{ selection.label }}
                        </mat-option>
                        }
                    </mat-select>
                    @for (validator of getValidators(field); track
                    validator.errorKey ?? validator.name) {
                    <mat-error>
                        {{
                            t(
                                validator.messageKey ??
                                    validator.message ??
                                    validator.name
                            ) ??
                                validator.messageKey ??
                                validator.message
                        }}
                    </mat-error>
                    } @if (formGroup.get(field.key)?.hasError('email')) {
                    <mat-error>{{ t("shared.error.email") }}</mat-error>
                    }
                </mat-form-field>
                }
                <!-- SINGLE-SELECT (SingleSelectionControlComponent) -->
                @if (field.type === 'single-select') { @if (field.options$ |
                async; as options) {
                <app-single-selection-control
                    [formGroup]="formGroup"
                    [selections]="options"
                    [formControlName]="field.key"
                    [control]="formGroup.get(field.key)"
                    [label]="field.labelKey ? t(field.labelKey) : ''"
                    [required]="isFieldRequired(field)"
                    [requiredErrorKey]="getRequiredErrorKey(field)"
                    [formSubmitted]="formSubmitted"
                    [requiredMessage]="
                        t(
                            getValidatorMessage(field, 'requireFieldWhen') ??
                                getValidatorMessage(field, 'required') ??
                                ''
                        )
                    "
                >
                </app-single-selection-control>
                } }
                <!-- MULTI-SELECT (MultiSelectionControlComponent) -->
                @if (field.type === 'multi-select') { @if (field.options$ |
                async; as options) {
                <div fxLayout="column" fxFlex="100">
                    <app-multi-selection-control
                        [formGroup]="formGroup"
                        [control]="formGroup.get(field.key)"
                        [selections]="options"
                        [formControlName]="field.key"
                        [label]="t(field.labelKey ?? field.label ?? field.key)"
                        [required]="isFieldRequired(field)"
                        [requiredErrorKey]="getRequiredErrorKey(field)"
                        [formSubmitted]="formSubmitted"
                        [requiredMessage]="
                            t(
                                getValidatorMessage(
                                    field,
                                    'requireFieldWhen'
                                ) ??
                                    getValidatorMessage(field, 'required') ??
                                    ''
                            )
                        "
                    >
                    </app-multi-selection-control>
                    @for ( validator of getValidators(field) ; track
                    validator.errorKey ?? validator.name) {
                    <mat-error>
                        @if (validator.name !== 'required') {
                        <div>
                            {{
                                t(
                                    validator.messageKey ??
                                        validator.message ??
                                        validator.name
                                ) ??
                                    validator.messageKey ??
                                    validator.message
                            }}
                        </div>
                        }
                    </mat-error>
                    }
                </div>
                } }
                <!-- SITE-SELECT (MultiSelectionControlComponent for provider sites) -->
                @if (field.type === 'site-select') { @if (field.options$ |
                async; as options) {
                <div fxLayout="column" fxFlex="100">
                    <app-multi-selection-control
                        [formGroup]="formGroup"
                        [control]="formGroup.get(field.key)"
                        [selections]="options"
                        [formControlName]="field.key"
                        [label]="t(field.labelKey ?? field.label ?? field.key)"
                        [required]="isFieldRequired(field)"
                        [requiredErrorKey]="getRequiredErrorKey(field)"
                        [formSubmitted]="formSubmitted"
                        [requiredMessage]="
                            t(
                                getValidatorMessage(
                                    field,
                                    'requireFieldWhen'
                                ) ??
                                    getValidatorMessage(field, 'required') ??
                                    ''
                            )
                        "
                    >
                    </app-multi-selection-control>
                    @for ( validator of getValidators(field) ; track
                    validator.errorKey ?? validator.name) {
                    <mat-error>
                        @if (validator.name !== 'required') {
                        <div>
                            {{
                                t(
                                    validator.messageKey ??
                                        validator.message ??
                                        validator.name
                                ) ??
                                    validator.messageKey ??
                                    validator.message
                            }}
                        </div>
                        }
                    </mat-error>
                    }
                </div>
                } }
                <!-- POSTAL CODE -->
                @if (field.type === 'postal-code') {
                <mat-form-field appearance="outline">
                    <mat-label>{{
                        t(field.labelKey ?? field.label ?? field.key)
                    }}</mat-label>
                    <input
                        matInput
                        [formControlName]="field.key"
                        [autocomplete]="'postalCode' | autocomplete"
                        maxlength="20"
                        [required]="isFieldRequired(field)"
                        inputmode="numeric"
                    />
                    @for (validator of getValidators(field); track
                    validator.errorKey ?? validator.name) {
                    <mat-error>
                        {{
                            t(
                                validator.messageKey ??
                                    validator.message ??
                                    validator.name
                            ) ??
                                validator.messageKey ??
                                validator.message
                        }}
                    </mat-error>
                    }
                </mat-form-field>
                }
                <!-- SSN INPUT -->
                @if (field.type === 'ssn') {
                <mat-form-field appearance="outline">
                    <mat-label>{{
                        t(field.labelKey ?? field.label ?? field.key)
                    }}</mat-label>
                    <app-ssn-input
                        [formControlName]="field.key"
                        #ssn
                        [required]="isFieldRequired(field)"
                    ></app-ssn-input>
                    <!-- <mat-error
                        *ngIf="
                            !formGroup.get(field.key)?.hasError('required') &&
                            ssn.errorState
                        "
                          >{{ t("shared.error.pattern.ssn") }}
                        </mat-error> -->
                    <mat-hint>###-##-####</mat-hint>
                    @for (validator of getValidators(field); track
                    validator.errorKey ?? validator.name) {
                    <mat-error>
                        {{
                            t(
                                validator.messageKey ??
                                    validator.message ??
                                    validator.name
                            ) ??
                                validator.messageKey ??
                                validator.message
                        }}
                    </mat-error>
                    } @if ( !formGroup .get(field.key) ?.hasError('required') &&
                    formGroup.get(field.key)?.hasError('pattern') ) {
                    <mat-error>{{ t("shared.error.pattern.ssn") }} </mat-error>
                    }
                </mat-form-field>
                }
                <!-- PHONE INPUT -->
                @if (field.type === 'phone') {
                <mat-form-field appearance="outline">
                    <mat-label>{{
                        t(field.labelKey ?? field.label ?? field.key)
                    }}</mat-label>
                    @if (field.key !== 'WorkPhone') {
                    <app-phone-input
                        [formControlName]="field.key"
                        #phoneInput
                        [required]="isFieldRequired(field)"
                    ></app-phone-input>
                    } @if (field.key === 'WorkPhone') {
                    <app-phone-input
                        [formControlName]="field.key"
                        #phoneInput
                        [required]="isFieldRequired(field)"
                        [showExtension]="true"
                    ></app-phone-input>
                    } @for (validator of getValidators(field); track
                    validator.errorKey ?? validator.name) {
                    <mat-error>
                        {{
                            t(
                                validator.messageKey ??
                                    validator.message ??
                                    validator.name
                            ) ??
                                validator.messageKey ??
                                validator.message
                        }}
                    </mat-error>
                    } @if ( formGroup.get(field.key)?.hasError('pattern') ) {
                    <mat-error>{{ t("shared.error.pattern.phone") }}</mat-error>
                    }
                </mat-form-field>
                }
                <!-- CHECKBOX -->
                @if (field.type === 'checkbox') {
                <mat-checkbox
                    [id]="field.key"
                    class="checkbox-signature full-width"
                    [formControlName]="field.key"
                >
                    {{ t(field.labelKey ?? field.label ?? field.key) }}
                </mat-checkbox>
                @for (validator of getValidators(field); track
                validator.errorKey ?? validator.name) {
                <mat-error>
                    {{
                        t(
                            validator.messageKey ??
                                validator.message ??
                                validator.name
                        ) ??
                            validator.messageKey ??
                            validator.message
                    }}
                </mat-error>
                } }
                <!-- SIGNATURE DATE-->
                @if (field.type === 'signature-date') {
                <mat-form-field appearance="outline" class="date-field">
                    <mat-label>{{ t("shared.field.currentDate") }}</mat-label>
                    <input
                        matInput
                        appDateMask
                        [matDatepicker]="signaturePicker"
                        [formControlName]="field.key"
                        maxlength="10"
                        [required]="isFieldRequired(field)"
                    />
                    @if ( formGroup.get(field.key)?.hasError('required') ) {
                    <mat-error>
                        {{ t("shared.error.required.currentDate") }}
                    </mat-error>
                    } @if ( formGroup .get(field.key) ?.hasError('invalidDate')
                    ) {
                    <mat-error>
                        {{ t("shared.error.signatureDate") }}
                    </mat-error>
                    }
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="signaturePicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #signaturePicker></mat-datepicker>
                    <mat-hint>MM/DD/YYYY</mat-hint>
                </mat-form-field>
                }
                <!-- FUTURE YEAR DATE -->
                @if (field.type === 'future-year-date') {
                <mat-form-field appearance="outline" class="date-field">
                    <mat-label>{{
                        t(field.labelKey ?? field.label ?? field.key)
                    }}</mat-label>
                    <input
                        matInput
                        type="number"
                        [formControlName]="field.key"
                        [autocomplete]="field.key | autocomplete"
                        min="{{ currentYear - 100 }}"
                        max="{{ currentYear }}"
                        maxlength="4"
                        placeholder="{{ currentYear }}"
                        [required]="isFieldRequired(field)"
                    />
                    @if ( formGroup.get(field.key)?.hasError('pattern') ) {
                    <mat-error>{{
                        t("shared.error.pattern.future-year-date")
                    }}</mat-error>
                    } @if ( formGroup.get(field.key)?.hasError('required') ) {
                    <mat-error>
                        {{ t("shared.error.required.last-school-year") }}
                    </mat-error>
                    } @if ( formGroup.get(field.key)?.hasError('futureYear') ) {
                    <mat-error>{{ t("shared.error.future-year") }} </mat-error>
                    }
                </mat-form-field>
                }
                <!-- INCOME -->
                @if (field.type === 'income') {
                <mat-form-field appearance="outline">
                    <mat-icon matPrefix>attach_money</mat-icon>
                    <mat-label>{{
                        field.labelKey ? t(field.labelKey) : ""
                    }}</mat-label>
                    <input
                        matInput
                        [formControlName]="field.key"
                        [autocomplete]="field.key | autocomplete"
                        type="number"
                        min="0"
                        max="10000000"
                        oninput="value = !!value && value < 0 ? value*-1 : value"
                        [required]="isFieldRequired(field)"
                    />
                    @if ( formGroup.get(field.key)?.hasError('required') ) {
                    <mat-error>
                        {{ t("shared.error.required.your-income") }}
                    </mat-error>
                    }
                </mat-form-field>
                }
                <!-- SIGNATURE -->
                @if (field.type === 'signature') {
                <div fxLayout="column" fxLayout.xs="column">
                    <div>
                        <p
                            class="sub-title"
                            [id]="field.key + '-signature-label'"
                        >
                            {{
                                t(
                                    "application.disclosure.student-signature-label"
                                )
                            }}
                        </p>
                    </div>
                    <div>
                        <mat-checkbox
                            [id]="field.key"
                            class="checkbox-signature"
                            [formControlName]="field.key"
                            [aria-describedby]="getAriaDescribedBy(field.key)"
                        >
                            {{ t(field.labelKey ?? field.label ?? field.key) }}
                        </mat-checkbox>
                        @for ( validator of getValidators(field) ; track
                        validator.errorKey ?? validator.name) {
                        <mat-error>
                            {{
                                t(
                                    validator.messageKey ??
                                        validator.message ??
                                        validator.name
                                ) ??
                                    validator.messageKey ??
                                    validator.message
                            }}
                        </mat-error>
                        }
                    </div>
                    @if (formGroup.get(field.key)?.value) {
                    <div class="signature-line">
                        <mat-label class="signature">
                            {{
                                $safeNavigationMigration(
                                    formGroup.get("StudentSignatureFirstName")
                                        ?.value
                                )
                                    | fullName
                                        : $safeNavigationMigration(
                                              formGroup.get(
                                                  "StudentSignatureLastName"
                                              )?.value
                                          )
                            }}
                        </mat-label>
                        <mat-divider></mat-divider>
                    </div>
                    }
                </div>
                }
            </div>
            } }
        </div>
    </div>
    }
</ng-container>
